// extracted by mini-css-extract-plugin
export default {"heroContainer":"Hero_heroContainer__Fih7k","heading":"Hero_heading__q6oZS","heroSubHeading":"Hero_heroSubHeading__JAhmB"};